import { Component, OnDestroy, OnInit, AfterViewInit, Renderer2 } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ResizeObserver } from '@juggle/resize-observer';

@Component({
  selector: 'layout-nest',
  template: `
    <nz-layout>
      <nz-content>
        <div class="content-title" nz-row nzJustify="space-between">
          <div nz-col *ngIf="!hideContentTitle">
            <span class="text">{{ contentTitle }}</span>
          </div>
          <div nz-col nzFlex="auto" [class.width-100]="hideContentTitle">
            <div nz-row nzJustify="space-between">
              <div nz-col><router-outlet name="titleLeft"></router-outlet></div>
              <div nz-col><router-outlet name="titleRight"></router-outlet></div>
            </div>
          </div>
        </div>

        <div class="content"><router-outlet></router-outlet></div>
      </nz-content>
    </nz-layout>
  `,
  styles: [
    `
      :host {
        display: flex;
        text-rendering: optimizeLegibility;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        min-height: 100%;
        min-width: 100%;
      }

      nz-content {
        min-height: 100%;
      }

      .content-title {
        margin-top: 3px;
        margin-bottom: 8px;
      }

      .content-title .text {
        font-size: 22px;
        font-weight: bold;
      }
    `
  ]
})
export class LayoutNestComponent implements OnInit, OnDestroy, AfterViewInit {
  contentTitle: string;
  hideContentTitle: boolean;

  private destroy$: Subject<void> = new Subject<void>();
  private resizeObserver: ResizeObserver;

  constructor(
    private readonly store: Store<{ layout: { title: string; hideContentTitle: boolean } }>,
    private readonly renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.store
      .select(state => state.layout)
      .pipe(takeUntil(this.destroy$))
      .subscribe(layout => {
        this.contentTitle = layout.title ?? '未设置标题';
        this.hideContentTitle = layout.hideContentTitle;
      });
  }

  ngAfterViewInit(): void {
    this.resizeObserver = new ResizeObserver(entries => {
      if (window.parent && document.querySelector('nz-content')) {
        const scrollDom = window.parent.document || document;
        const iframeSelf = scrollDom.getElementsByTagName('iframe')[0];
        if (iframeSelf) {
          this.renderer.setAttribute(iframeSelf, 'height', '0');
        }
        window.parent.postMessage(
          { type: 'currentHeight', data: document.querySelector('nz-content').scrollHeight },
          '*'
        );
      }
    });

    this.resizeObserver.observe(document.querySelector('nz-content'));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.resizeObserver.disconnect();
  }
}
